import { useActiveKidDisciplinesApi } from '@api/kids/active-kid-disciplines.hook'

export default defineNuxtRouteMiddleware(() => {
  void useActiveKidDisciplinesApi()
})
